import AccountService from 'wanderu-service-account';

import {
    actions as bookingActions,
} from '../../appstate';
import {
    namespace,
    actions,
    selectors,
    reducer,
} from './base';

function checkAccountExists(userEmail) {
    return async (dispatch, getState) => {
        const hasFetched = selectors.selectSuccess(getState(), userEmail);
        const isFetching = selectors.selectWorking(getState(), userEmail);

        let userAccountExists = false;
        let meta;

        if (isFetching || !userEmail) {
            return;
        }

        if (hasFetched) {
            userAccountExists = selectors.idSelector(getState(), userEmail).userAccountExists;
            dispatch(bookingActions.setAccountExists({
                userAccountExists,
                userEmail,
            }));
        } else {
            dispatch(actions.startWork(userEmail));

            userAccountExists = await AccountService.accountExistsForEmail(userEmail);
            meta = {
                userAccountExists,
            };

            dispatch(bookingActions.setAccountExists({
                userAccountExists,
                userEmail,
            }));

            dispatch(actions.endWork(userEmail, meta, undefined));
        }
    };
}

const checkAccountExistsAction = {
    checkAccountExists,
    ...selectors,
};

export {
    checkAccountExistsAction,
};

export default {
    [namespace]: reducer,
};
